export default __webpack_public_path__ + "static/media/pause.507ad168.svg";